import {
  EARN_DETAILS_STATE,
  EarnDirectDetailsData,
  UseEarnDetailsDataHandlers,
} from '../../types/detailsState'
import { formatUsd } from '../../utils/utils'
import { useEarnDetailsBaseData } from './useEarnDetailsBaseData'

export const useEarnDirectDetailsData = (
  portfolioId: string | undefined,
  handlers: UseEarnDetailsDataHandlers
): EarnDirectDetailsData => {
  const baseData = useEarnDetailsBaseData(portfolioId, handlers)

  if (baseData.detailsState !== EARN_DETAILS_STATE.READY) {
    return baseData
  }

  const { details, merchantStatistics: _merchantStatistics, ...viewData } = baseData

  return {
    ...viewData,
    myLifetimeEarnings: formatUsd(details.totalEarnings.fromMyAllocation),
  }
}
